import { post, get } from '../axios'

// collection分页查询, 条件和价格过滤
export function service_col_filter_page_post(map, option) {
  return post(
    `${process.env.VUE_APP_SERVICE}/service/col/filter/page`,
    map,
    option
  ).then(response => response)
}

// collection分页查询, 不支持条件和价格过滤
export function service_col_page_get(map, option) {
  return get(
    `${process.env.VUE_APP_SERVICE}/service/col/page`,
    map,
    option
  ).then(response => response)
}

// collection筛选项
export function service_col_queryFilterInfo_get(map, option) {
  return get(
    `${process.env.VUE_APP_SERVICE}/service/col/queryFilterInfo`,
    map,
    option
  ).then(response => response)
}

// 查询Collection商品信息（促销用）
export function service_collection_promotion_batchGet_post(map, option) {
  return post(
    `${process.env.VUE_APP_SERVICE}/service/collection/promotion/batchGet`,
    map,
    option
  ).then(response => response)
}

// 分页查询Collection基础信息（促销用）
export function service_collection_promotion_validList_post(map, option) {
  return post(
    `${process.env.VUE_APP_SERVICE}/service/collection/promotion/validList`,
    map,
    option
  ).then(response => response)
}

// 自研collection seo信息
export function service_col_seo_info_get(map, option) {
  return get(
    `${process.env.VUE_APP_SERVICE}/service/col/seo/info`,
    map,
    option
  ).then(response => response)
}

// 查询skc详细信息
export function service_col_skc_detail_get(map, option) {
  return get(
    `${process.env.VUE_APP_SERVICE}/service/col/skc/detail`,
    map,
    option
  ).then(response => response)
}

// 模糊删除缓存key
export function col_cache_del_get(map, option) {
  return get(`${process.env.VUE_APP_COL}/col/cache/del`, map, option).then(
    response => response
  )
}

// 设置缓存开关
export function col_cache_set_get(map, option) {
  return get(`${process.env.VUE_APP_COL}/col/cache/set`, map, option).then(
    response => response
  )
}

// collection分页查询, 条件和价格过滤
export function col_filter_page_post(map, option) {
  return post(`${process.env.VUE_APP_COL}/col/filter/page`, map, option).then(
    response => response
  )
}

// collection分页查询, 不支持条件和价格过滤
export function col_page_get(map, option) {
  return get(`${process.env.VUE_APP_COL}/col/page`, map, option).then(
    response => response
  )
}

// collection筛选项
export function col_queryFilterInfo_get(map, option) {
  return get(
    `${process.env.VUE_APP_COL}/col/queryFilterInfo`,
    map,
    option
  ).then(response => response)
}

// 自研collection seo信息
export function col_seo_info_get(map, option) {
  return get(`${process.env.VUE_APP_COL}/col/seo/info`, map, option).then(
    response => response
  )
}

// 自研collection白名单
export function col_seo_urls_get(map, option) {
  return get(`${process.env.VUE_APP_COL}/col/seo/urls`, map, option).then(
    response => response
  )
}

// 查询skc详细信息
export function col_skc_detail_get(map, option) {
  return get(`${process.env.VUE_APP_COL}/col/skc/detail`, map, option).then(
    response => response
  )
}

// 查询collection skc信息
export function col_skc_info_post(map, option) {
  return post(`${process.env.VUE_APP_COL}/col/skc/info`, map, option).then(
    response => response
  )
}
